// storeData.js — 2. El Mağaza biçim/yardımcı fonksiyonları (website data.php karşılıkları).
//
// Veri API'dendir (storeApi.js: urunCevir ile ürün nesnesine çevrilir). Bu modülde yalnız
// görünümlerin ortak kullandığı biçimlendirme ve hesap yardımcıları kalır.

/** İlanda ad görünümü seçenekleri (İlan Ver › İletişim). */
export const AD_GORUNUMLERI = {
  tam: "Adınız açık görünür",
  kisa: "Soyadınızın baş harfi",
  "soyad-gizle": "Soyadınız gizli",
  "tumu-gizle": "Ad ve soyad gizli",
};

// Küsuratlı fiyat kuruşuyla (49,99 TL), tam sayı küsuratsız (27.000 TL) — website storeFiyat ile aynı.
export function storeFiyat(n) {
  const v = Math.round((Number(n) || 0) * 100) / 100;
  const k = Math.abs(v - Math.round(v)) >= 0.005;
  return `${v.toLocaleString("tr-TR", { minimumFractionDigits: k ? 2 : 0, maximumFractionDigits: k ? 2 : 0 })} TL`;
}

export function storeIndirim(u) {
  if (!u?.eskiFiyat || u.eskiFiyat <= u.fiyat) return 0;
  return Math.round((1 - u.fiyat / u.eskiFiyat) * 100);
}

/**
 * "Zeynep Bozkurt" → tam: Zeynep Bozkurt · kisa: Zeynep B. · soyad-gizle: Zeynep B*** · tumu-gizle: Z*** B***
 * Yıldız sayısı sabit (***): gerçek uzunluk sızmasın.
 */
export function adMaskele(ad, tur) {
  const parca = String(ad || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parca.length) return "";
  const bas = (k) => k.charAt(0);
  const soyad = parca.length > 1 ? parca.pop() : "";
  const adlar = parca.join(" ");
  switch (tur) {
    case "kisa":
      return soyad === "" ? adlar : `${adlar} ${bas(soyad)}.`;
    case "soyad-gizle":
      return soyad === "" ? adlar : `${adlar} ${bas(soyad)}***`;
    case "tumu-gizle": {
      const m = parca.map((k) => `${bas(k)}***`);
      if (soyad !== "") m.push(`${bas(soyad)}***`);
      return m.join(" ");
    }
    default:
      return `${adlar} ${soyad}`.trim();
  }
}

/** Kartta ve detayda gösterilecek satıcı etiketi. */
export function saticiAdi(u) {
  if (u?.saticiTipi === "troy") return "Troy Depo";
  const ad = String(u?.satici?.ad || "").trim();
  return ad !== "" ? adMaskele(ad, u?.satici?.adGorunum || "tam") : "Üye ilanı";
}

/** Üye ilanında alıcının satıcıya ulaşma yolu: 'telefon' veya 'mesaj' (Troy Depo üzerinden). */
export function iletisimTercihi(u) {
  const tel = String(u?.satici?.telefon || "").trim();
  let tercih = String(u?.satici?.iletisim || "");
  if (tercih === "telefon" && tel === "") tercih = "mesaj";
  if (tercih === "") tercih = tel !== "" ? "telefon" : "mesaj";
  return tercih;
}

/** "0532 000 00 05" → "0532 *** ** 05". */
export function telMaskele(tel) {
  let r = String(tel || "").replace(/\D+/g, "");
  if (r.length === 12 && r.startsWith("90")) r = `0${r.slice(2)}`; // panel biçimi: +90 5xx …
  if (r.length < 6) return "*** ** **";
  return `${r.slice(0, 4)} *** ** ${r.slice(-2)}`;
}

/** Troy ürününde depo, üye ilanında ilçe/şehir. */
export function konumAdi(u) {
  // Troy Depo ürünü: depo adı; depoda değilse ("Diğer") ilçe, il.
  return u?.saticiTipi === "troy" && String(u?.depo || "").trim() ? String(u.depo) : String(u?.konum || "");
}

/** Ürünün görülüp teslim alınacağı yer: Evden / Ofisten / Depodan. Troy ürünü her zaman depodan. */
export function teslimYeri(u) {
  if (u?.saticiTipi === "troy" && String(u?.depo || "").trim()) return "Depodan";
  return String(u?.teslimYeri || "");
}

const AYLAR = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];

/** Unix zaman (sn) → "2 Eki 2026". */
export function tarihTr(t) {
  const d = new Date(t * 1000);
  return `${d.getUTCDate()} ${AYLAR[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** "2026-09-08" → "8 Eyl 2026". */
export function isoTarihTr(iso) {
  const [y, m, g] = String(iso || "")
    .split("-")
    .map(Number);
  if (!y || !m || !g) return "";
  return `${g} ${AYLAR[m - 1]} ${y}`;
}

/** İki fiyat arası yüzde (−12,5 gibi), tek ondalık. */
export function priceChange(onceki, yeni) {
  return onceki > 0 ? Math.round(((yeni - onceki) / onceki) * 1000) / 10 : 0;
}

/** Görsel yer tutucusu — data-URI SVG (dış istek yok). */
export function placeholderImg(harf, etiket, hue) {
  const h = Math.round(hue);
  const esc = (v) => String(v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600">` +
    `<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">` +
    `<stop offset="0" stop-color="hsl(${h},42%,90%)"/>` +
    `<stop offset="1" stop-color="hsl(${h},34%,70%)"/>` +
    `</linearGradient></defs>` +
    `<rect width="800" height="600" fill="url(#g)"/>` +
    `<circle cx="400" cy="270" r="150" fill="hsl(${h},30%,80%)" opacity="0.6"/>` +
    `<text x="400" y="340" font-family="Arial,sans-serif" font-size="200" font-weight="700" fill="hsl(${h},28%,52%)" text-anchor="middle" opacity="0.65">${esc(harf)}</text>` +
    `<text x="400" y="500" font-family="Arial,sans-serif" font-size="38" font-weight="500" fill="hsl(${h},22%,42%)" text-anchor="middle">${esc(etiket)}</text>` +
    `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** Galeri: ilanın gerçek görselleri; hiç yoksa tek harf yer tutucu (website storeProductMedia). */
export function productMedia(u) {
  const medya = (u?.gorseller || []).map((src, i) => ({
    tip: "image",
    src,
    etiket: i === 0 ? "Kapak" : `${i + 1}. fotoğraf`,
  }));
  // Video (store-ext, en fazla 1): her zaman kapaktan hemen sonra, 2. sırada.
  if (medya.length && /^https:\/\//.test(String(u?.video || ""))) {
    medya.splice(1, 0, {
      tip: "video",
      src: u.video,
      poster: medya[0].src,
      etiket: "Video",
    });
  }
  if (medya.length) return medya;
  const harf = String(u?.ad || "?")
    .charAt(0)
    .toLocaleUpperCase("tr-TR");
  let h = 0;
  for (const c of String(u?.slug || "")) h = (h * 31 + c.charCodeAt(0)) % 360;
  return [
    {
      tip: "image",
      src: placeholderImg(harf, "Fotoğraf yok", h),
      etiket: "Fotoğraf yok",
    },
  ];
}

/**
 * Ürünün kargo ücreti (TL, ADET BAŞINA). Üründe kargoUcreti varsa o (0 = ücretsiz kargo);
 * yoksa tarife hacme göre: <0,5 m³ 150 · <1,5 m³ 450 · <3 m³ 850 · üstü 1.500 · toplu satış 3.500
 * (website storeKargoUcreti; yalnız Troy Depo ürünlerinin sepetinde kullanılır).
 */
export function kargoUcreti(u) {
  if (u && u.kargoUcreti !== undefined && u.kargoUcreti !== null) return Math.max(0, Math.trunc(Number(u.kargoUcreti) || 0));
  if (u?.kategori === "depodan-toplu-satis") return 3500;
  const h = Number(u?.hacim) || 0;
  if (h < 0.5) return 150;
  if (h < 1.5) return 450;
  if (h < 3) return 850;
  return 1500;
}

/** "Ücretsiz kargo" ya da "Kargo: 450 TL". */
export function kargoMetni(u) {
  const k = kargoUcreti(u);
  return k === 0 ? "Ücretsiz kargo" : `Kargo: ${storeFiyat(k)}`;
}

/** Sepet kargo toplamı = Σ satır kargo ücreti (satır başına bir kez; çoklu adette adetle çarpılmaz — API ile aynı). */
export function cartShipping(items) {
  return (items || []).reduce((t, u) => t + kargoUcreti(u), 0);
}

// Çoklu adet (16.10.2026): stoklu sarf ürünleri (paketleme) sepete en fazla COKLU_ADET_MAX adet girer, satılınca ilan
// kapanmaz; diğer ürünler tek parça (stok 1). API store-ext COKLU_ADET_KATEGORILER ve website storeCokluAdet ile AYNI liste.
export const COKLU_ADET_MAX = 50;
export const cokluAdet = (altSlug) => ["paketleme-malzemeleri"].includes(String(altSlug || ""));

/**
 * T.C. kimlik no algoritma kontrolü. Boşsa '' değil hata mesajı döner; geçerliyse ''.
 * (Nüfus kaydıyla doğrulama DEĞİL — gerçekte NVİ servisi ayrıca gerekir.)
 */
export function tcknHata(t) {
  if (t === "") return "T.C. kimlik numarası zorunludur.";
  if (!/^[0-9]+$/.test(t)) return "Yalnız rakam girin.";
  if (t.length !== 11) return `11 haneli olmalı (${t.length}/11).`;
  if (t[0] === "0") return "T.C. kimlik numarası 0 ile başlayamaz.";
  const d = t.split("").map(Number);
  const tek = d[0] + d[2] + d[4] + d[6] + d[8];
  const cift = d[1] + d[3] + d[5] + d[7];
  const ilk10 = d.slice(0, 10).reduce((a, b) => a + b, 0);
  if ((((tek * 7 - cift) % 10) + 10) % 10 !== d[9] || ilk10 % 10 !== d[10]) {
    return "Geçerli bir T.C. kimlik numarası değil. Lütfen kontrol edin.";
  }
  return "";
}

export function tcknGecerli(t) {
  return tcknHata(String(t || "")) === "";
}

/** "10000000146" → "100******46". */
export function tcknMaskele(t) {
  const r = String(t || "").replace(/\D+/g, "");
  return r.length === 11 ? `${r.slice(0, 3)}******${r.slice(-2)}` : "";
}
